var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("burguer", { staticClass: "mobile-only" }),
        _vm._v(" "),
        _c(
          "div",
          {
            on: {
              click: function($event) {
                _vm.changeMenu()
              }
            }
          },
          [
            _c(
              "router-link",
              {
                staticClass: "logo",
                attrs: { to: { name: "dashboard" } },
                on: {
                  click: function($event) {
                    _vm.clickedOn()
                  }
                }
              },
              [_c("img", { attrs: { src: "/static/logo-vertical.svg" } })]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "list" }, [
          _c(
            "li",
            {
              class: { active: _vm.isActiveRoute("purchase-flow") },
              on: {
                click: function($event) {
                  _vm.changeMenu()
                }
              }
            },
            [
              _c("router-link", { attrs: { to: { name: "purchase-flow" } } }, [
                _c("img", { attrs: { src: "/static/menu-services.svg" } }),
                _vm._v("agendar limpezas\n        ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  _vm.changeMenu("orders")
                }
              }
            },
            [
              _c("img", { attrs: { src: "/static/menu-orders.svg" } }),
              _vm._v("minhas limpezas\n      ")
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.isActiveRoute("help") },
              on: {
                click: function($event) {
                  _vm.changeMenu()
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  attrs: { to: { name: "help" } },
                  nativeOn: {
                    click: function($event) {
                      _vm.sendEvents("help")
                    }
                  }
                },
                [
                  _c("img", { attrs: { src: "/static/icon-question.svg" } }),
                  _vm._v("ajuda\n        ")
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "user" }, [
          _c(
            "li",
            {
              staticClass: "dashboard",
              class: { active: _vm.$route.name === "dashboard" }
            },
            [
              _c("router-link", { attrs: { to: { name: "dashboard" } } }, [
                _c("img", { attrs: { src: "/static/dashboard.svg" } })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-image", on: { click: _vm.changeDropdown } },
            [
              _c("img", {
                attrs: {
                  src: _vm.user.profile.profile_picture,
                  alt: _vm.user.first_name + " " + _vm.user.last_name
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown",
              on: {
                click: function($event) {
                  _vm.dropdownVisible = !_vm.dropdownVisible
                }
              }
            },
            [
              _c("img", {
                attrs: { src: "/static/arrow-down.svg", width: "10px" }
              }),
              _vm._v(" "),
              _c("transition", { attrs: { name: "down", mode: "in-out" } }, [
                _vm.dropdownVisible
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.closeDropdown,
                            expression: "closeDropdown"
                          }
                        ],
                        staticClass: "dropdown-menu"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: { name: "personal-data" } },
                            nativeOn: {
                              click: function($event) {
                                _vm.sendEvents("personal-data")
                              }
                            }
                          },
                          [_vm._v("\n              Minha Conta\n            ")]
                        ),
                        _vm._v(" "),
                        _c("span", { on: { click: _vm.callLogout } }, [
                          _vm._v("Sair")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51c0c71e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c0c71e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar/Menu.vue
// module id = null
// module chunks = 